import { useEffect } from "react";
import { devLogger } from "@/lib/logger";
import { STARTUP_MOUNT_EVENT } from "@/lib/startupWatchdog";

let hasDispatchedStartupMountSignal = false;

type WindowEventDispatcher = Pick<Window, "dispatchEvent">;

export const dispatchStartupMountSignalOnce = (
  label?: string,
  windowRef?: WindowEventDispatcher | null,
) => {
  if (typeof window === "undefined" && !windowRef) {
    return false;
  }

  if (hasDispatchedStartupMountSignal) {
    return false;
  }

  hasDispatchedStartupMountSignal = true;
  devLogger.log("[startup] startup-mounted signal dispatched", { label: label ?? "unknown" });

  const targetWindow = windowRef ?? window;
  targetWindow.dispatchEvent(new Event(STARTUP_MOUNT_EVENT));
  return true;
};

export const useStartupMountSignalOnce = (label?: string) => {
  useEffect(() => {
    dispatchStartupMountSignalOnce(label);
  }, [label]);
};

export const __resetStartupMountSignalForTests = () => {
  hasDispatchedStartupMountSignal = false;
};
